module.exports = __webpack_public_path__ + "static/media/UnsupportedBrowser.13026b19.svg";